export default {
  title: {
    en: 'Add a few helpful tags!',
  },
  likes: {
    en: 'Likes',
  },
  dislikes: {
    en: 'Could be better',
  },
}
